export default __webpack_public_path__ + "static/nodejs-007e99f68b718e476aba958058d83a8c.png";